var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2000 900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-4 {\n        opacity: .1;\n      }\n\n      .cls-4, .cls-5 {\n        fill: #333;\n      }\n\n      .cls-6 {\n        letter-spacing: 0em;\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-9 {\n        fill: #f4f4f6;\n      }\n\n      .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15 {\n        fill: #fff;\n      }\n\n      .cls-16 {\n        fill: #999;\n      }\n\n      .cls-17 {\n        fill: #1a1a1a;\n      }\n\n      .cls-18, .cls-19 {\n        fill: #4d4d4d;\n      }\n\n      .cls-20 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-11 {\n        font-family: Montserrat-Bold, Montserrat;\n        font-size: 36.41px;\n        font-weight: 700;\n      }\n\n      .cls-21 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-22 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-23 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-24 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-25 {\n        fill: url(#radial-gradient-2);\n        mix-blend-mode: screen;\n      }\n\n      .cls-26 {\n        letter-spacing: 0em;\n      }\n\n      .cls-27 {\n        letter-spacing: 0em;\n      }\n\n      .cls-28 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-29 {\n        letter-spacing: 0em;\n      }\n\n      .cls-30 {\n        letter-spacing: 0em;\n      }\n\n      .cls-31 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-32 {\n        letter-spacing: -.05em;\n      }\n\n      .cls-33 {\n        fill: gray;\n        font-size: 16.01px;\n      }\n\n      .cls-33, .cls-13, .cls-15 {\n        font-family: Montserrat-Medium, Montserrat;\n        font-weight: 500;\n      }\n\n      .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: .8px;\n      }\n\n      .cls-34 {\n        letter-spacing: 0em;\n      }\n\n      .cls-35 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-36 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-38 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-39 {\n        letter-spacing: 0em;\n      }\n\n      .cls-40 {\n        letter-spacing: 0em;\n      }\n\n      .cls-41 {\n        fill: url(#Degradado_sin_nombre_2-2);\n      }\n\n      .cls-41, .cls-42, .cls-19, .cls-12, .cls-14 {\n        fill-rule: evenodd;\n      }\n\n      .cls-43 {\n        fill: url(#radial-gradient);\n        mix-blend-mode: multiply;\n      }\n\n      .cls-44 {\n        letter-spacing: 0em;\n      }\n\n      .cls-42 {\n        fill: url(#Degradado_sin_nombre_2);\n      }\n\n      .cls-45 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-46 {\n        fill: url(#Degradado_sin_nombre_3);\n      }\n\n      .cls-13 {\n        font-size: 11.21px;\n      }\n\n      .cls-47 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-48 {\n        isolation: isolate;\n      }\n\n      .cls-49 {\n        letter-spacing: 0em;\n      }\n\n      .cls-14 {\n        filter: url(#drop-shadow-1);\n      }\n\n      .cls-50 {\n        letter-spacing: 0em;\n      }\n\n      .cls-15 {\n        font-size: 14.41px;\n      }\n\n      .cls-51 {\n        letter-spacing: -.02em;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m184.26,484.91h24.72l26.11,63.69h1.11l26.11-63.69h24.72v94.79h-19.44v-61.7h-.79l-24.53,61.24h-13.24l-24.53-61.47h-.79v61.93h-19.44v-94.79Zm150.98,96.18c-7.19,0-13.4-1.54-18.63-4.61-5.23-3.07-9.27-7.36-12.1-12.87-2.84-5.51-4.26-11.9-4.26-19.19s1.42-13.77,4.26-19.28c2.84-5.51,6.87-9.8,12.1-12.87,5.23-3.07,11.44-4.61,18.63-4.61s13.4,1.54,18.63,4.61c5.23,3.07,9.26,7.36,12.1,12.87,2.84,5.51,4.26,11.93,4.26,19.28s-1.42,13.68-4.26,19.19c-2.84,5.51-6.87,9.8-12.1,12.87-5.23,3.07-11.44,4.61-18.63,4.61Zm.09-15.27c3.27,0,6-.93,8.19-2.8,2.19-1.87,3.85-4.42,4.98-7.66s1.69-6.93,1.69-11.06-.56-7.82-1.69-11.06c-1.13-3.24-2.78-5.8-4.98-7.68-2.19-1.88-4.92-2.82-8.19-2.82s-6.07.94-8.31,2.82c-2.24,1.88-3.92,4.44-5.04,7.68-1.13,3.24-1.69,6.93-1.69,11.06s.56,7.82,1.69,11.06c1.13,3.24,2.81,5.79,5.04,7.66,2.24,1.87,5.01,2.8,8.31,2.8Zm48.14,13.89v-94.79h19.72v35.64h.6c.86-1.91,2.12-3.87,3.77-5.86,1.65-1.99,3.81-3.66,6.48-5,2.67-1.34,5.99-2.01,9.97-2.01,5.18,0,9.97,1.35,14.35,4.05,4.38,2.7,7.88,6.76,10.51,12.17,2.62,5.42,3.93,12.2,3.93,20.34s-1.27,14.62-3.82,20.07-6,9.57-10.37,12.36c-4.37,2.79-9.25,4.19-14.65,4.19-3.83,0-7.07-.63-9.74-1.9-2.67-1.27-4.85-2.86-6.55-4.79-1.7-1.93-2.99-3.88-3.89-5.86h-.88v11.39h-19.44Zm19.3-35.55c0,4.23.59,7.92,1.76,11.06,1.17,3.15,2.87,5.59,5.09,7.34,2.22,1.74,4.92,2.62,8.1,2.62s5.92-.89,8.15-2.66c2.22-1.77,3.91-4.24,5.07-7.41,1.16-3.16,1.74-6.81,1.74-10.95s-.57-7.71-1.71-10.83c-1.14-3.12-2.82-5.55-5.05-7.31-2.22-1.76-4.95-2.64-8.19-2.64s-5.92.85-8.12,2.55c-2.21,1.7-3.9,4.1-5.07,7.22-1.17,3.12-1.76,6.79-1.76,11.02Zm73.04-44.71c-2.93,0-5.44-.98-7.52-2.94-2.08-1.96-3.12-4.31-3.12-7.06s1.04-5.05,3.12-7.01c2.08-1.96,4.59-2.94,7.52-2.94s5.44.98,7.52,2.94c2.08,1.96,3.12,4.3,3.12,7.01s-1.04,5.1-3.12,7.06c-2.08,1.96-4.59,2.94-7.52,2.94Zm-9.91,80.26v-71.1h19.72v71.1h-19.72Zm55.17-94.79v94.79h-19.72v-94.79h19.72Zm48.14,96.18c-7.31,0-13.6-1.49-18.86-4.47-5.26-2.98-9.31-7.21-12.15-12.68-2.84-5.48-4.26-11.96-4.26-19.46s1.42-13.73,4.26-19.25c2.84-5.52,6.84-9.83,12.01-12.91,5.17-3.08,11.24-4.63,18.21-4.63,4.69,0,9.06.75,13.12,2.25,4.06,1.5,7.61,3.74,10.65,6.73,3.04,2.99,5.41,6.75,7.1,11.27,1.7,4.52,2.55,9.81,2.55,15.85v5.42h-60.03v-12.22h41.47c0-2.84-.62-5.35-1.85-7.54-1.23-2.19-2.94-3.91-5.11-5.16-2.18-1.25-4.7-1.87-7.57-1.87s-5.64.69-7.94,2.06c-2.3,1.37-4.1,3.21-5.39,5.51s-1.96,4.85-1.99,7.66v11.62c0,3.52.66,6.56,1.97,9.12,1.31,2.56,3.17,4.54,5.58,5.92,2.41,1.39,5.26,2.08,8.56,2.08,2.19,0,4.2-.31,6.02-.93,1.82-.62,3.38-1.54,4.67-2.78,1.3-1.23,2.28-2.75,2.96-4.54l18.24,1.2c-.93,4.38-2.82,8.2-5.67,11.46-2.85,3.26-6.53,5.79-11.02,7.59-4.49,1.81-9.67,2.71-15.53,2.71Zm92.43-1.39h-21.48l32.72-94.79h25.83l32.68,94.79h-21.48l-23.75-73.13h-.74l-23.79,73.13Zm-1.34-37.26h50.73v15.65h-50.73v-15.65Zm82.11,63.92v-97.76h19.44v11.94h.88c.86-1.91,2.12-3.87,3.77-5.86,1.65-1.99,3.81-3.66,6.48-5,2.67-1.34,5.99-2.01,9.97-2.01,5.18,0,9.97,1.35,14.35,4.05,4.38,2.7,7.88,6.76,10.51,12.17,2.62,5.42,3.93,12.2,3.93,20.34s-1.27,14.62-3.82,20.07c-2.55,5.45-6,9.57-10.37,12.36-4.37,2.79-9.25,4.19-14.65,4.19-3.83,0-7.07-.63-9.74-1.9-2.67-1.27-4.85-2.86-6.55-4.79-1.7-1.93-2.99-3.88-3.89-5.86h-.6v38.05h-19.72Zm19.3-62.21c0,4.23.59,7.92,1.76,11.06,1.17,3.15,2.87,5.59,5.09,7.34,2.22,1.74,4.92,2.62,8.1,2.62s5.92-.89,8.15-2.66,3.91-4.24,5.07-7.41,1.74-6.81,1.74-10.95-.57-7.71-1.71-10.83c-1.14-3.12-2.82-5.55-5.05-7.31-2.22-1.76-4.95-2.64-8.19-2.64s-5.92.85-8.12,2.55c-2.21,1.7-3.9,4.1-5.07,7.22-1.17,3.12-1.76,6.79-1.76,11.02Zm63.13,62.21v-97.76h19.44v11.94h.88c.86-1.91,2.12-3.87,3.77-5.86,1.65-1.99,3.81-3.66,6.48-5,2.67-1.34,5.99-2.01,9.97-2.01,5.18,0,9.97,1.35,14.35,4.05,4.38,2.7,7.88,6.76,10.51,12.17,2.62,5.42,3.93,12.2,3.93,20.34s-1.27,14.62-3.82,20.07c-2.55,5.45-6,9.57-10.37,12.36-4.37,2.79-9.25,4.19-14.65,4.19-3.83,0-7.07-.63-9.74-1.9-2.67-1.27-4.85-2.86-6.55-4.79-1.7-1.93-2.99-3.88-3.89-5.86h-.6v38.05h-19.72Zm19.3-62.21c0,4.23.59,7.92,1.76,11.06,1.17,3.15,2.87,5.59,5.09,7.34,2.22,1.74,4.92,2.62,8.1,2.62s5.92-.89,8.15-2.66,3.91-4.24,5.07-7.41,1.74-6.81,1.74-10.95-.57-7.71-1.71-10.83c-1.14-3.12-2.82-5.55-5.05-7.31-2.22-1.76-4.95-2.64-8.19-2.64s-5.92.85-8.12,2.55c-2.21,1.7-3.9,4.1-5.07,7.22-1.17,3.12-1.76,6.79-1.76,11.02Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 136.56,
    y1: 650.1,
    x2: 1006.49,
    y2: 417.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232323"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1417.06,
    y1: 839.68,
    x2: 1417.06,
    y2: 60.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3",
    "data-name": "Degradado sin nombre 3",
    x1: 1227.79,
    y1: 450,
    x2: 1602.5,
    y2: 450,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1236,
    y: 66,
    width: 360,
    height: 769,
    rx: 38.27,
    ry: 38.27
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2",
    "data-name": "Degradado sin nombre 2",
    x1: 1203.43,
    y1: 330.1,
    x2: 1482.75,
    y2: 330.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2-2",
    "data-name": "Degradado sin nombre 2",
    x1: 6044.07,
    y1: 648.09,
    x2: 6323.4,
    y2: 648.09,
    gradientTransform: "translate(7653.03 1197.36) rotate(-180)",
    xlinkHref: "#Degradado_sin_nombre_2"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12.81
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 11.21
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1446.77,
    y1: 95.45,
    x2: 1446.77,
    y2: 83.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050607"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 579.49,
    y1: 40.18,
    x2: 579.49,
    y2: 33.44,
    gradientTransform: "translate(2026.26 126.81) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#11161f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354039"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1448.89,
    y1: 91.96,
    x2: 1444.65,
    y2: 87.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#212125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#242c36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#283f52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2e587a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3678ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#3b8bca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#346e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#2d5270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#283b4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#242b33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#212124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#211e1f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 1446.77,
    cy: 89.84,
    fx: 1446.77,
    fy: 89.84,
    r: 2.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#234758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#256f91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#278dbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#289fd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#29a6de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#289ed3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#278bb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#256b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#223f4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#211e1f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 1448.41,
    cy: 91.4,
    fx: 1448.41,
    fy: 91.4,
    r: 1.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8c8c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c4c4c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#898988"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#585857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    width: 2000,
    height: 900
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1067,
    y: 100,
    width: 700,
    height: 700
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1117,
    y: 150,
    width: 600,
    height: 600
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1167,
    y: 200,
    width: 500,
    height: 500
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1217,
    y: 250,
    width: 400,
    height: 400
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 140.23,
    y: 403.3,
    width: 862.58,
    height: 260.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m332.97,421.55v26.18h-3.95v-26.18h3.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m346.65,455.51c-1.56,0-2.9-.2-4.02-.61s-2.03-.95-2.74-1.62c-.71-.67-1.24-1.41-1.58-2.21l3.29-1.36c.23.38.54.77.93,1.2.39.42.92.78,1.58,1.08.67.3,1.53.45,2.59.45,1.45,0,2.65-.35,3.59-1.05.95-.7,1.42-1.82,1.42-3.36v-3.86h-.24c-.23.42-.56.88-.99,1.39-.43.51-1.02.96-1.77,1.33-.75.38-1.73.56-2.93.56-1.55,0-2.95-.36-4.19-1.09-1.24-.73-2.22-1.81-2.94-3.23s-1.08-3.19-1.08-5.27.36-3.88,1.07-5.37c.71-1.49,1.69-2.63,2.93-3.43,1.24-.8,2.65-1.2,4.23-1.2,1.22,0,2.2.2,2.95.61.75.41,1.34.88,1.76,1.41s.75,1.01.98,1.42h.28v-3.18h3.75v20.07c0,1.69-.39,3.07-1.18,4.16-.78,1.08-1.84,1.88-3.18,2.4-1.33.52-2.84.78-4.51.78Zm-.04-11.24c1.1,0,2.03-.26,2.79-.77s1.34-1.26,1.74-2.22c.4-.97.59-2.13.59-3.48s-.2-2.48-.59-3.49c-.39-1-.97-1.79-1.73-2.36-.76-.57-1.7-.85-2.81-.85s-2.11.3-2.88.89c-.77.59-1.34,1.4-1.73,2.41-.39,1.01-.58,2.15-.58,3.4s.2,2.42.59,3.39c.39.97.97,1.73,1.74,2.28.77.54,1.72.82,2.86.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m364.46,436.08v11.66h-3.82v-19.64h3.67v3.2h.24c.45-1.04,1.16-1.88,2.13-2.51.97-.63,2.19-.95,3.66-.95,1.34,0,2.51.28,3.52.84,1.01.56,1.79,1.39,2.34,2.49.55,1.1.83,2.46.83,4.08v12.49h-3.82v-12.03c0-1.42-.37-2.54-1.11-3.34-.74-.81-1.76-1.21-3.06-1.21-.89,0-1.67.19-2.36.58s-1.23.94-1.62,1.68c-.4.74-.59,1.62-.59,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m384.07,425.07c-.66,0-1.23-.22-1.71-.67-.47-.45-.71-.98-.71-1.6s.24-1.17.71-1.62c.47-.45,1.04-.67,1.71-.67s1.23.22,1.71.67c.47.45.71.99.71,1.62s-.24,1.16-.71,1.6c-.47.45-1.04.67-1.71.67Zm-1.93,22.67v-19.64h3.82v19.64h-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m400.27,428.1v3.07h-10.73v-3.07h10.73Zm-7.85-4.7h3.82v18.58c0,.74.11,1.3.33,1.67.22.37.51.62.86.75.35.13.74.2,1.16.2.31,0,.58-.02.81-.06.23-.04.41-.08.54-.1l.69,3.16c-.22.08-.54.17-.95.26-.41.09-.92.14-1.53.15-1.01.02-1.94-.16-2.81-.54-.87-.38-1.57-.95-2.11-1.74-.54-.78-.81-1.77-.81-2.95v-19.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m406.42,425.07c-.66,0-1.23-.22-1.71-.67-.47-.45-.71-.98-.71-1.6s.24-1.17.71-1.62c.47-.45,1.04-.67,1.71-.67s1.23.22,1.71.67c.47.45.71.99.71,1.62s-.24,1.16-.71,1.6c-.47.45-1.04.67-1.71.67Zm-1.93,22.67v-19.64h3.82v19.64h-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m417.27,436.08v11.66h-3.82v-19.64h3.67v3.2h.24c.45-1.04,1.16-1.88,2.13-2.51.97-.63,2.19-.95,3.66-.95,1.34,0,2.51.28,3.52.84,1.01.56,1.79,1.39,2.34,2.49.55,1.1.83,2.46.83,4.08v12.49h-3.82v-12.03c0-1.42-.37-2.54-1.11-3.34-.74-.81-1.76-1.21-3.06-1.21-.89,0-1.67.19-2.36.58s-1.23.94-1.62,1.68c-.4.74-.59,1.62-.59,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m443.18,455.51c-1.56,0-2.9-.2-4.02-.61s-2.03-.95-2.74-1.62c-.71-.67-1.24-1.41-1.58-2.21l3.29-1.36c.23.38.54.77.93,1.2.39.42.92.78,1.58,1.08.67.3,1.53.45,2.59.45,1.45,0,2.65-.35,3.59-1.05.95-.7,1.42-1.82,1.42-3.36v-3.86h-.24c-.23.42-.56.88-.99,1.39-.43.51-1.02.96-1.77,1.33-.75.38-1.73.56-2.93.56-1.55,0-2.95-.36-4.19-1.09-1.24-.73-2.22-1.81-2.94-3.23s-1.08-3.19-1.08-5.27.36-3.88,1.07-5.37c.71-1.49,1.69-2.63,2.93-3.43,1.24-.8,2.65-1.2,4.23-1.2,1.22,0,2.2.2,2.95.61.75.41,1.34.88,1.76,1.41s.75,1.01.98,1.42h.28v-3.18h3.75v20.07c0,1.69-.39,3.07-1.18,4.16-.78,1.08-1.84,1.88-3.18,2.4-1.33.52-2.84.78-4.51.78Zm-.04-11.24c1.1,0,2.03-.26,2.79-.77s1.34-1.26,1.74-2.22c.4-.97.59-2.13.59-3.48s-.2-2.48-.59-3.49c-.39-1-.97-1.79-1.73-2.36-.76-.57-1.7-.85-2.81-.85s-2.11.3-2.88.89c-.77.59-1.34,1.4-1.73,2.41-.39,1.01-.58,2.15-.58,3.4s.2,2.42.59,3.39c.39.97.97,1.73,1.74,2.28.77.54,1.72.82,2.86.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m467.01,421.55h4.79l8.34,20.35h.31l8.34-20.35h4.79v26.18h-3.76v-18.95h-.24l-7.72,18.91h-3.12l-7.72-18.92h-.24v18.96h-3.76v-26.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m507.3,448.13c-1.84,0-3.45-.42-4.82-1.27-1.37-.84-2.44-2.02-3.2-3.54-.76-1.52-1.14-3.29-1.14-5.32s.38-3.82,1.14-5.34,1.82-2.71,3.2-3.55c1.37-.84,2.98-1.27,4.82-1.27s3.45.42,4.82,1.27c1.37.84,2.44,2.03,3.2,3.55s1.14,3.31,1.14,5.34-.38,3.8-1.14,5.32c-.76,1.52-1.82,2.7-3.2,3.54-1.37.84-2.98,1.27-4.82,1.27Zm.01-3.21c1.19,0,2.18-.32,2.97-.95.78-.63,1.37-1.47,1.74-2.52.38-1.05.57-2.2.57-3.46s-.19-2.41-.57-3.46c-.38-1.05-.96-1.9-1.74-2.54-.78-.64-1.77-.96-2.97-.96s-2.2.32-2.98.96c-.79.64-1.37,1.49-1.75,2.54-.38,1.05-.57,2.21-.57,3.46s.19,2.42.57,3.46c.38,1.05.96,1.89,1.75,2.52.79.63,1.78.95,2.98.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m521.01,447.74v-26.18h3.82v9.73h.23c.22-.41.54-.88.96-1.42s1-1.01,1.74-1.41c.74-.4,1.72-.61,2.94-.61,1.58,0,3,.4,4.24,1.2,1.24.8,2.22,1.96,2.93,3.46.71,1.51,1.07,3.32,1.07,5.45s-.35,3.94-1.06,5.45-1.68,2.68-2.92,3.49c-1.24.81-2.65,1.22-4.23,1.22-1.19,0-2.17-.2-2.92-.6-.75-.4-1.34-.87-1.77-1.41-.43-.54-.75-1.01-.98-1.43h-.32v3.06h-3.73Zm3.75-9.82c0,1.38.2,2.59.6,3.63.4,1.04.98,1.85,1.74,2.44.76.58,1.69.88,2.79.88s2.1-.3,2.86-.91,1.35-1.44,1.75-2.49c.4-1.05.59-2.23.59-3.54s-.19-2.46-.58-3.49c-.39-1.03-.97-1.84-1.74-2.44s-1.73-.89-2.88-.89-2.04.29-2.81.86-1.34,1.37-1.73,2.39c-.39,1.02-.59,2.22-.59,3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m545.16,425.07c-.66,0-1.23-.22-1.71-.67-.47-.45-.71-.98-.71-1.6s.24-1.17.71-1.62c.47-.45,1.04-.67,1.71-.67s1.23.22,1.71.67c.47.45.71.99.71,1.62s-.24,1.16-.71,1.6c-.47.45-1.04.67-1.71.67Zm-1.93,22.67v-19.64h3.82v19.64h-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m556.02,421.55v26.18h-3.82v-26.18h3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m569.62,448.13c-1.94,0-3.6-.42-4.99-1.25-1.39-.83-2.47-2-3.22-3.52-.75-1.51-1.13-3.29-1.13-5.32s.38-3.78,1.13-5.32,1.81-2.73,3.17-3.59c1.36-.86,2.95-1.29,4.77-1.29,1.11,0,2.18.18,3.22.55,1.04.37,1.97.94,2.8,1.73s1.48,1.8,1.96,3.05c.48,1.25.72,2.76.72,4.54v1.35h-15.61v-2.86h11.86c0-1.01-.2-1.9-.61-2.68-.41-.78-.98-1.4-1.72-1.85-.74-.45-1.6-.68-2.59-.68-1.07,0-2.01.26-2.81.79-.8.52-1.41,1.21-1.84,2.05-.43.84-.65,1.75-.65,2.73v2.24c0,1.31.23,2.43.7,3.35.46.92,1.11,1.62,1.95,2.1.83.48,1.81.72,2.93.72.72,0,1.39-.1,1.98-.31.6-.21,1.11-.52,1.55-.94.43-.42.77-.93,1-1.55l3.62.65c-.29,1.07-.81,2-1.55,2.79-.75.8-1.68,1.42-2.8,1.85-1.12.44-2.4.66-3.83.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m606.42,428.43c-.14-1.21-.7-2.15-1.69-2.82s-2.23-1-3.73-1c-1.07,0-2,.17-2.79.5-.78.34-1.39.8-1.82,1.38-.43.58-.65,1.25-.65,1.99,0,.62.15,1.16.44,1.61.29.45.68.83,1.16,1.13s1,.55,1.55.75c.55.2,1.09.37,1.6.49l2.56.67c.84.21,1.69.48,2.57.83.88.35,1.69.81,2.44,1.38s1.36,1.28,1.82,2.12c.46.84.7,1.85.7,3.03,0,1.48-.38,2.8-1.14,3.95-.76,1.15-1.87,2.06-3.31,2.72-1.44.67-3.19,1-5.24,1s-3.66-.31-5.09-.93-2.55-1.51-3.36-2.65-1.26-2.51-1.34-4.08h3.96c.08.95.39,1.73.93,2.36.54.63,1.24,1.09,2.08,1.39s1.78.45,2.79.45c1.12,0,2.11-.18,2.99-.53.87-.35,1.56-.85,2.06-1.48s.75-1.38.75-2.23c0-.78-.22-1.41-.66-1.9s-1.03-.9-1.78-1.23c-.75-.32-1.59-.61-2.52-.86l-3.09-.84c-2.1-.57-3.76-1.41-4.98-2.52-1.22-1.11-1.83-2.57-1.83-4.4,0-1.51.41-2.83,1.23-3.95.82-1.12,1.93-2,3.32-2.63,1.4-.63,2.97-.94,4.73-.94s3.34.31,4.7.93,2.43,1.48,3.22,2.56c.78,1.09,1.19,2.33,1.23,3.74h-3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m623.27,448.13c-1.84,0-3.45-.42-4.82-1.27-1.37-.84-2.44-2.02-3.2-3.54-.76-1.52-1.14-3.29-1.14-5.32s.38-3.82,1.14-5.34,1.82-2.71,3.2-3.55c1.37-.84,2.98-1.27,4.82-1.27s3.45.42,4.82,1.27c1.37.84,2.44,2.03,3.2,3.55s1.14,3.31,1.14,5.34-.38,3.8-1.14,5.32c-.76,1.52-1.82,2.7-3.2,3.54-1.37.84-2.98,1.27-4.82,1.27Zm.01-3.21c1.19,0,2.18-.32,2.97-.95.78-.63,1.37-1.47,1.74-2.52.38-1.05.57-2.2.57-3.46s-.19-2.41-.57-3.46c-.38-1.05-.96-1.9-1.74-2.54-.78-.64-1.77-.96-2.97-.96s-2.2.32-2.98.96c-.79.64-1.37,1.49-1.75,2.54-.38,1.05-.57,2.21-.57,3.46s.19,2.42.57,3.46c.38,1.05.96,1.89,1.75,2.52.79.63,1.78.95,2.98.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m640.5,421.55v26.18h-3.82v-26.18h3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m658.08,439.59v-11.49h3.84v19.64h-3.76v-3.4h-.2c-.45,1.05-1.17,1.92-2.17,2.61-.99.69-2.23,1.04-3.7,1.04-1.26,0-2.38-.28-3.34-.84-.97-.56-1.73-1.39-2.28-2.49s-.82-2.46-.82-4.08v-12.49h3.82v12.03c0,1.34.37,2.4,1.11,3.2.74.79,1.7,1.19,2.89,1.19.72,0,1.43-.18,2.14-.54.71-.36,1.3-.9,1.78-1.62.47-.72.71-1.65.7-2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m676.21,428.1v3.07h-10.73v-3.07h10.73Zm-7.85-4.7h3.82v18.58c0,.74.11,1.3.33,1.67.22.37.51.62.86.75.35.13.74.2,1.16.2.31,0,.58-.02.81-.06.23-.04.41-.08.54-.1l.69,3.16c-.22.08-.54.17-.95.26-.41.09-.92.14-1.53.15-1.01.02-1.94-.16-2.81-.54-.87-.38-1.57-.95-2.11-1.74-.54-.78-.81-1.77-.81-2.95v-19.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m682.36,425.07c-.66,0-1.23-.22-1.71-.67-.47-.45-.71-.98-.71-1.6s.24-1.17.71-1.62c.47-.45,1.04-.67,1.71-.67s1.23.22,1.71.67c.47.45.71.99.71,1.62s-.24,1.16-.71,1.6c-.47.45-1.04.67-1.71.67Zm-1.93,22.67v-19.64h3.82v19.64h-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m697.66,448.13c-1.84,0-3.45-.42-4.82-1.27-1.37-.84-2.44-2.02-3.2-3.54-.76-1.52-1.14-3.29-1.14-5.32s.38-3.82,1.14-5.34,1.82-2.71,3.2-3.55c1.37-.84,2.98-1.27,4.82-1.27s3.45.42,4.82,1.27c1.37.84,2.44,2.03,3.2,3.55s1.14,3.31,1.14,5.34-.38,3.8-1.14,5.32c-.76,1.52-1.82,2.7-3.2,3.54-1.37.84-2.98,1.27-4.82,1.27Zm.01-3.21c1.19,0,2.18-.32,2.97-.95.78-.63,1.37-1.47,1.74-2.52.38-1.05.57-2.2.57-3.46s-.19-2.41-.57-3.46c-.38-1.05-.96-1.9-1.74-2.54-.78-.64-1.77-.96-2.97-.96s-2.2.32-2.98.96c-.79.64-1.37,1.49-1.75,2.54-.38,1.05-.57,2.21-.57,3.46s.19,2.42.57,3.46c.38,1.05.96,1.89,1.75,2.52.79.63,1.78.95,2.98.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m714.89,436.08v11.66h-3.82v-19.64h3.67v3.2h.24c.45-1.04,1.16-1.88,2.13-2.51.97-.63,2.19-.95,3.66-.95,1.34,0,2.51.28,3.52.84,1.01.56,1.79,1.39,2.34,2.49.55,1.1.83,2.46.83,4.08v12.49h-3.82v-12.03c0-1.42-.37-2.54-1.11-3.34-.74-.81-1.76-1.21-3.06-1.21-.89,0-1.67.19-2.36.58s-1.23.94-1.62,1.68c-.4.74-.59,1.62-.59,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m747.29,432.89l-3.46.61c-.14-.44-.37-.87-.68-1.27-.31-.4-.73-.73-1.26-.98s-1.19-.38-1.98-.38c-1.08,0-1.99.24-2.71.72s-1.09,1.1-1.09,1.86c0,.66.24,1.19.73,1.59.49.4,1.27.73,2.35.98l3.12.72c1.81.42,3.15,1.06,4.04,1.93.89.87,1.33,2,1.33,3.39,0,1.18-.34,2.22-1.02,3.14-.68.92-1.62,1.63-2.83,2.15-1.21.52-2.6.78-4.19.78-2.2,0-3.99-.47-5.38-1.41-1.39-.94-2.24-2.28-2.56-4.02l3.69-.56c.23.96.7,1.69,1.42,2.18.72.49,1.65.74,2.8.74,1.25,0,2.25-.26,3-.79s1.12-1.17,1.12-1.92c0-.61-.23-1.13-.68-1.55-.46-.42-1.15-.73-2.09-.95l-3.32-.73c-1.83-.42-3.19-1.08-4.06-1.99-.87-.91-1.31-2.07-1.31-3.46,0-1.16.32-2.17.97-3.04s1.54-1.55,2.68-2.04c1.14-.49,2.45-.73,3.92-.73,2.12,0,3.79.46,5.01,1.37s2.02,2.14,2.42,3.67Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 487.72,
    y: 278.64,
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m561.65,304.76v37.2h-47.85v-37.2h47.85m5.24-5.24h-58.33v47.68h58.33v-47.68h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 546.96,
    y: 310.45,
    width: 5.24,
    height: 17.29,
    transform: "translate(-64.67 482.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 540.93,
    y: 325,
    width: 17.29,
    height: 5.24,
    transform: "translate(-70.69 484.57) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 523.24,
    y: 318.97,
    width: 5.24,
    height: 17.29,
    transform: "translate(-77.64 467.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 517.22,
    y: 316.48,
    width: 17.29,
    height: 5.24,
    transform: "translate(-71.61 465.3) rotate(-45)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 529.77,
    y: 347.28,
    width: 15.89,
    height: 5.24
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "557.63 352.52 517.81 352.52 512.81 357.76 562.63 357.76 557.63 352.52"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m1606.21,305.86l-.13.16-.48.56h-1.2v480.26c0,4.88-.66,9.6-1.9,14.09-1.1,3.98-2.65,7.77-4.6,11.31-.21.37-.41.74-.63,1.11-.38.67-.78,1.33-1.19,1.97-9.39,14.65-25.81,24.36-44.5,24.36h-267.75c-29.17,0-52.83-23.66-52.83-52.84v-437.29h-1.29v-.02h-1.19l-.13-.16-.47-.57c.28-5.95.3-48.41,0-54.53v-.05l.6-.75h2.48v-14.21h-1.29v-.02h-1.19l-.13-.16-.47-.57c.28-5.93.3-48.39,0-54.53v-.05l.6-.73v-.02h1.19v.02h1.29v-35.95h-1.29v-.02h-1.19l-.13-.16-.47-.56c.28-5.93.3-22.89,0-28.9v-.05l.6-.73v-.02h1.19v.02h1.29v-43.89c0-9.57,2.55-18.55,7-26.29.64-1.11,1.32-2.19,2.03-3.24,9.49-14.06,25.57-23.3,43.8-23.3h267.75c24.29,0,44.75,16.41,50.92,38.74,1.24,4.49,1.9,9.21,1.9,14.09v110.24h1.2v.02l.61.73c-.3,5.97-.28,75.98,0,81.93Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m1602.5,98.85v702.08c-1.1,3.98-2.65,7.77-4.6,11.31-.21.37-.41.74-.63,1.11-.38.67-.78,1.33-1.19,1.97-9.36,14.77-25.85,24.57-44.63,24.57h-267.74c-29.18,0-52.84-23.66-52.84-52.83v-437.3h-1.29v-.02h-1.19l-.6-.73c.28-5.97.3-48.63,0-54.58l.13-.16v-.05l.6-.75h2.35v-14h-1.29v-.02h-1.19l-.6-.72c.28-5.96.3-48.62,0-54.59l.13-.16v-.05l.6-.73v-.02h1.19v.02h1.16v-35.73h-1.29v-.02h-1.19l-.6-.73c.28-5.95.3-22.98,0-28.95l.13-.16v-.05l.6-.73v-.02h1.19v.02h1.16v-43.67c0-9.66,2.59-18.72,7.13-26.51.64-1.11,1.32-2.19,2.03-3.24,9.49-14.06,25.57-23.3,43.8-23.3h267.75c24.29,0,44.75,16.41,50.92,38.74Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m1203.43,619.75c61.35-26.16,32.57-193.87,54.9-232.24,29.18-50.14,61.7-40.83,87.73-77.93,41.73-59.49,20.45-177.21,48.94-213.01,27.62-34.7,87.77-49.2,87.77-56.11h-279.33v579.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m1608.96,259.63c-61.35,26.16-32.57,193.87-54.9,232.24-29.18,50.14-61.7,40.83-87.73,77.93-41.73,59.49-20.45,177.21-48.94,213.01-27.62,34.7-87.77,49.2-87.77,56.11h279.33V259.63Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m1536.05,608.15h-242.01c-12.43,0-22.5-10.07-22.5-22.5h0c0-12.43,10.07-22.5,22.5-22.5h242.01c12.43,0,22.5,10.07,22.5,22.5h0c0,12.43-10.07,22.5-22.5,22.5Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-33",
    transform: "translate(1389.65 590.47)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 0,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.4,
    y: 0
  }, "og In"))), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m1468.29,787.64h-106.49c-12.43,0-22.5-10.07-22.5-22.5h0c0-12.43,10.07-22.5,22.5-22.5h106.49c12.43,0,22.5,10.07,22.5,22.5h0c0,12.43-10.07,22.5-22.5,22.5Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-33",
    transform: "translate(1388.43 772.48)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 11.58,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-47",
    x: 17.95,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.51,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 37.08,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 43.42,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(1284.77 422.24)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Usee"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 36.26,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 42.06,
    y: 0
  }, "na"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 60.5,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 75.77,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1271.54,
    y1: 438.14,
    x2: 1558.55,
    y2: 438.14
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(1284.77 496.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 0,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.19,
    y: 0
  }, "as"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 26.03,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 33.1,
    y: 0
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    x: 45.84,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 54.99,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 60.73,
    y: 0
  }, "d")), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1271.54,
    y1: 512.86,
    x2: 1558.55,
    y2: 512.86
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(1364.06 631.15)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 0,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.93,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 14.04,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.5,
    y: 0
  }, "got "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-50",
    x: 41.01,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 48.6,
    y: 0
  }, "as"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 60.92,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 66.42,
    y: 0
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 76.33,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 83.45,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 87.91,
    y: 0
  }, "d?")), /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(1345.79 727.02)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Don\xB4t h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 46.02,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 52.61,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 58.71,
    y: 0
  }, "e an "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 85.93,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 92.67,
    y: 0
  }, "cc"), /*#__PURE__*/React.createElement("tspan", {
    x: 105.29,
    y: 0
  }, "oun"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 127.63,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 132.08,
    y: 0
  }, "?")), /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(1328.77 359.65)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 0,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 40.34,
    y: 0
  }, "el"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 74.27,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 95.53,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 119.37,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 157.78,
    y: 0
  }, "e!")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1359.54,
    y: 123.65,
    width: 111.01,
    height: 104.25,
    rx: 26.62,
    ry: 26.62
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(1375.98 269.52)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "App")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m1393.16,142.11c-9.31,0-16.88,7.57-16.88,16.89,0,13.99,15.56,25.64,16.22,26.13l.66.48.66-.48c.66-.49,16.23-12.14,16.23-26.13,0-9.32-7.58-16.89-16.89-16.89Zm0,40.72c-2.94-2.37-14.67-12.52-14.67-23.83,0-8.09,6.58-14.67,14.67-14.67s14.67,6.58,14.67,14.67c0,11.31-11.73,21.46-14.67,23.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m1436.93,142.11c-9.31,0-16.89,7.57-16.89,16.89,0,13.99,15.57,25.64,16.23,26.13l.66.48.66-.48c.66-.49,16.23-12.14,16.23-26.13,0-9.32-7.58-16.89-16.89-16.89Zm0,40.72c-2.94-2.37-14.67-12.52-14.67-23.83,0-8.09,6.58-14.67,14.67-14.67s14.67,6.58,14.67,14.67c0,11.31-11.73,21.46-14.67,23.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m1440.08,190.27c-.79-.66-1.83-1.12-2.92-1.23-1.08-.09-2.19.12-3.1.62-.47.21-.86.55-1.27.84-.35.36-.7.7-1.01,1.08-.08.1-.1.23-.06.35.07.19.28.28.47.21l.05-.02c.44-.17.82-.39,1.23-.57.41-.14.79-.34,1.19-.44.5-.17.99-.24,1.47-.27-.33,5.21-2.67,10.12-6.72,13.12-4.04,3.07-9.23,4.45-14.38,4.45-5.15,0-10.35-1.38-14.38-4.45-4.05-3-6.39-7.92-6.72-13.12.49.03.98.1,1.47.27.4.1.78.31,1.19.44.41.17.79.4,1.23.57l.05.02c.12.04.25.03.35-.06.16-.12.18-.35.06-.51-.31-.38-.66-.72-1.01-1.08-.41-.28-.79-.62-1.27-.84-.9-.5-2.01-.71-3.1-.62-1.09.11-2.12.57-2.92,1.23-.81.66-1.41,1.47-1.79,2.42-.05.12-.03.27.07.37.13.15.36.16.51.03l.03-.03c1.11-.99,2.31-1.79,3.57-2.1-.13,2.74.32,5.54,1.36,8.16,1.11,2.69,2.93,5.1,5.16,6.99,4.5,3.82,10.44,5.42,16.13,5.45,5.69-.03,11.63-1.62,16.13-5.45,2.23-1.89,4.05-4.3,5.16-6.99,1.05-2.62,1.49-5.42,1.36-8.16,1.25.3,2.46,1.1,3.57,2.1l.03.03c.1.09.24.12.37.07.18-.07.27-.28.2-.47-.38-.95-.99-1.76-1.79-2.42Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m1393.16,166.68c-4.14,0-7.5-3.36-7.5-7.5s3.36-7.5,7.5-7.5,7.5,3.36,7.5,7.5-3.36,7.5-7.5,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m1436.93,166.68c-4.14,0-7.5-3.36-7.5-7.5s3.36-7.5,7.5-7.5,7.5,3.36,7.5,7.5-3.36,7.5-7.5,7.5Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m1602.5,99.55c-6-22.59-26.58-39.23-51.05-39.23h-267.74c-18.15,0-34.16,9.15-43.68,23.09-.71,1.05-1.39,2.13-2.03,3.24-4.54,7.79-7.13,16.85-7.13,26.51v673.9c0,29.17,23.66,52.83,52.84,52.83h267.74c18.78,0,35.27-9.8,44.63-24.57.41-.64.81-1.3,1.19-1.97.22-.37.42-.74.63-1.11,1.96-3.63,3.52-7.5,4.6-11.57,1.15-4.34,1.77-8.91,1.77-13.61V113.16c0-4.71-.61-9.27-1.77-13.61Zm-3.36,685.66c0,27.36-22.17,49.56-49.56,49.56h-264.02c-27.37,0-49.57-22.2-49.57-49.56V115c0-27.36,22.2-49.56,49.57-49.56h264.02c27.39,0,49.56,22.2,49.56,49.56v670.21Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m1549.58,65.44h-264.02c-27.37,0-49.57,22.2-49.57,49.56v670.21c0,27.36,22.2,49.56,49.57,49.56h264.02c27.39,0,49.56-22.2,49.56-49.56V115c0-27.36-22.17-49.56-49.56-49.56Zm47.01,51.05v667.23c0,26.78-21.71,48.47-48.5,48.47h-261.05c-26.78,0-48.49-21.69-48.49-48.47V116.49c0-26.78,21.71-48.49,48.49-48.49h261.05c26.79,0,48.5,21.71,48.5,48.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1548.09,67.76h-261.05c-26.86,0-48.73,21.87-48.73,48.73v667.23c0,26.86,21.87,48.74,48.73,48.74h261.05c26.89,0,48.76-21.88,48.76-48.74V116.49c0-26.86-21.87-48.73-48.76-48.73Zm48.26,715.96c0,26.6-21.66,48.23-48.26,48.23h-261.05c-26.6,0-48.23-21.63-48.23-48.23V116.49c0-26.6,21.63-48.23,48.23-48.23h261.05c26.6,0,48.26,21.63,48.26,48.23v667.23Zm-48.26-715.96h-261.05c-26.86,0-48.73,21.87-48.73,48.73v667.23c0,26.86,21.87,48.74,48.73,48.74h261.05c26.89,0,48.76-21.88,48.76-48.74V116.49c0-26.86-21.87-48.73-48.76-48.73Zm48.26,715.96c0,26.6-21.66,48.23-48.26,48.23h-261.05c-26.6,0-48.23-21.63-48.23-48.23V116.49c0-26.6,21.63-48.23,48.23-48.23h261.05c26.6,0,48.26,21.63,48.26,48.23v667.23Zm-46.75-718.54h-264.04c-27.47,0-49.83,22.36-49.83,49.82v670.21c0,27.46,22.36,49.82,49.83,49.82h264.04c27.47,0,49.8-22.36,49.8-49.82V115c0-27.46-22.33-49.82-49.8-49.82Zm49.3,720.03c0,27.18-22.11,49.32-49.3,49.32h-264.04c-27.19,0-49.32-22.14-49.32-49.32V115c0-27.18,22.13-49.31,49.32-49.31h264.04c27.19,0,49.3,22.13,49.3,49.31v670.21Zm-50.81-717.45h-261.05c-26.86,0-48.73,21.87-48.73,48.73v667.23c0,26.86,21.87,48.74,48.73,48.74h261.05c26.89,0,48.76-21.88,48.76-48.74V116.49c0-26.86-21.87-48.73-48.76-48.73Zm48.26,715.96c0,26.6-21.66,48.23-48.26,48.23h-261.05c-26.6,0-48.23-21.63-48.23-48.23V116.49c0-26.6,21.63-48.23,48.23-48.23h261.05c26.6,0,48.26,21.63,48.26,48.23v667.23Zm-48.26-715.96h-261.05c-26.86,0-48.73,21.87-48.73,48.73v667.23c0,26.86,21.87,48.74,48.73,48.74h261.05c26.89,0,48.76-21.88,48.76-48.74V116.49c0-26.86-21.87-48.73-48.76-48.73Zm48.26,715.96c0,26.6-21.66,48.23-48.26,48.23h-261.05c-26.6,0-48.23-21.63-48.23-48.23V116.49c0-26.6,21.63-48.23,48.23-48.23h261.05c26.6,0,48.26,21.63,48.26,48.23v667.23Zm-48.26-715.96h-261.05c-26.86,0-48.73,21.87-48.73,48.73v667.23c0,26.86,21.87,48.74,48.73,48.74h261.05c26.89,0,48.76-21.88,48.76-48.74V116.49c0-26.86-21.87-48.73-48.76-48.73Zm48.26,715.96c0,26.6-21.66,48.23-48.26,48.23h-261.05c-26.6,0-48.23-21.63-48.23-48.23V116.49c0-26.6,21.63-48.23,48.23-48.23h261.05c26.6,0,48.26,21.63,48.26,48.23v667.23Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1604.27,
    y: 223.39,
    width: 1.21,
    height: 83.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m1606.08,306.07l-.6.72v-83.38l.6.72c-.3,5.97-.28,75.98,0,81.93Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1228.39,
    y: 223.39,
    width: 1.19,
    height: 56.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m1228.39,223.41v56.04l-.6-.72c.28-5.96.3-48.62,0-54.59l.13-.16.47-.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1229.58,
    y: 223.41,
    width: 1.29,
    height: 56.06
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1228.39,
    y: 293.68,
    width: 1.19,
    height: 56.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m1228.39,293.68v56.06l-.6-.73c.28-5.97.3-48.63,0-54.58l.13-.16.47-.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1229.58,
    y: 293.68,
    width: 1.29,
    height: 56.08
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1228.39,
    y: 157.03,
    width: 1.19,
    height: 30.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m1228.39,157.05v30.4l-.6-.73c.28-5.95.3-22.98,0-28.95l.13-.16.47-.56Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1229.58,
    y: 157.05,
    width: 1.29,
    height: 30.42
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1450.56,103.54h-67.25c-7.57,0-13.7-6.13-13.7-13.7h0c0-7.57,6.13-13.7,13.7-13.7h67.25c7.57,0,13.7,6.13,13.7,13.7h0c0,7.57-6.13,13.7-13.7,13.7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-35",
    cx: 1446.77,
    cy: 89.84,
    r: 5.98
  }), /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 12,
    transform: "translate(1441 84)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAsSAAALEgHS3X78AAABI0lEQVQokVWQQVLrQAxEnzSS7MR/nY/hHMD9lySsgMPYGY/FwsGVaDWq6S51P+FuTuOYpRSsFMKDiKCUws/3l/xpFODp5SVP45giApmIKJkJQCmF17f33A3/n5/3JTNBhMyVzGRZFq7XK6213SSncdweIgiCFqWLDisFM8PdcXO0KAAWHqxrAxGKKmbO8XBgzeTfMBAeLG2hLQ1RwUS2nFuuvRtdBCCICGaGiNBaw8xsF7k7RQvDMBCxUeqio9bKNE+s64od+gP3pbuuR26Xuugwsw3GvP2rqiKyCeRGyMMJjw2jKqrKPM9czh+iP99fcjwe6fsed8fMIDdzrZV5npmmCXd/bPn69p61VsyMv16ttT3u5fwhj1hupvs9M/m8nB80v9C6be0BTZsBAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 1446.77,
    cy: 89.84,
    r: 3.42
  }), /*#__PURE__*/React.createElement("g", {
    id: "Camera"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m1449.76,89.85c0,1.65-1.34,2.99-2.99,2.99s-2.99-1.34-2.99-2.99,1.33-2.99,2.99-2.99,2.99,1.33,2.99,2.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m1449.76,89.85c0,1.65-1.34,2.99-2.99,2.99s-2.99-1.34-2.99-2.99,1.33-2.99,2.99-2.99,2.99,1.33,2.99,2.99Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m1449.48,91.4c0-.59-.48-1.07-1.07-1.07s-1.07.48-1.07,1.07.48,1.07,1.07,1.07,1.07-.48,1.07-1.07Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset4);
export default __webpack_public_path__ + "static/media/Asset 4.224c19d52ff5452412b438e039ac8e92.svg";
export { ForwardRef as ReactComponent };